<template>
  <div class="ifd-link-area compare-mode mt8 ta-right">
    <button class="btn btn-sm btn-info" @click="openInfraDoctor">
      インフラドクターを開く
    </button>
  </div>
</template>

<script setup lang="ts">
import { openNewInfraDoctorTab } from 'src/lib/moviePlayerHelper';
import type { GIMovie, GIMovieGeoIndex, GIMovieList } from 'src/models/geoItem';

const props = defineProps<{
  ifdLinkPrefix: string | undefined;
  currentMovie: GIMovie | null;
  currentMovieList: GIMovieList | null;
  currentMgi: GIMovieGeoIndex | null;
  currentMovieIdx: number;
  currentMgiIdx: number;
  isFirstMovie: boolean;
  isLastMovie: boolean;
  isReady: boolean;
}>();

const openInfraDoctor = (): void => {
  if (!props.isReady ||
    !props.ifdLinkPrefix ||
    !props.currentMovie ||
    !props.currentMovieList ||
    !props.currentMgi) return;

  openNewInfraDoctorTab({
    ifdLinkPrefix: props.ifdLinkPrefix,
    currentMovieList: props.currentMovieList,
    currentMovie: props.currentMovie,
    currentMovieIdx: props.currentMovieIdx,
    currentMgi: props.currentMgi,
    currentMgiIdx: props.currentMgiIdx,
    isFirstMovie: props.isFirstMovie,
    isLastMovie: props.isLastMovie,
  });
};
</script>
